export const AI_INTERVIEW_INVITE_STAGE = 'shortlisted';
export const AI_INTERVIEW_COMPLETED_STAGE = 'interviewed';

export function isDirectAiInterviewCompletionAdvance(
  fromStage: string | null | undefined,
  toStage: string | null | undefined,
  hasAiInterviews: boolean,
) {
  return !!hasAiInterviews && fromStage === AI_INTERVIEW_INVITE_STAGE && toStage === AI_INTERVIEW_COMPLETED_STAGE;
}

export function canShowInterviewInviteAction(stage: string | null | undefined) {
  return stage === AI_INTERVIEW_INVITE_STAGE || stage === AI_INTERVIEW_COMPLETED_STAGE;
}
